import { Modal, Icon, Transition, Header } from 'semantic-ui-react'
import SupportedBrowserGrid from './SupportedBrowserGrid'
import { Text } from 'preact-i18n'
import { useStore } from '../../../store'

const UnsupportedBrowserModal = () => {
  const store = useStore()
  const open = store.errorsStore.hasUnsupportedBrowserMessage.value
  return (
    <Transition visible={open} animation="scale" duration={350} unmountOnHide>
      <Modal id="unsupported-browser-modal" basic open={true} size="tiny">
        <Modal.Content>
          <Header icon inverted textAlign="center">
            <Icon name="warning sign" />
            <Text id="warnings.browser.unsupported.title">Unsupported Browser</Text>
          </Header>
          <p>
            <Text id="warnings.browser.unsupported.message">
              Please use any of the following browsers in order to be able to access this content.
            </Text>
          </p>
          <SupportedBrowserGrid />
        </Modal.Content>
      </Modal>
    </Transition>
  )
}
export default UnsupportedBrowserModal
